import React, { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  createActividad,
  getActividadById,
  updateActividad,
} from "./Actividades-Api";
import { isEmpty, userIsAdmin } from "../../util/Functions";
import { IaxTextField } from "../UIComponents/IaxTextField";
import { IaxDateField } from "../UIComponents/IaxDateField";
import { IaxTimeField } from "../UIComponents/IaxTimeField";
import { IaxNumericField } from "../UIComponents/IaxNumericField";
import { IaxCheckField } from "../UIComponents/IaxCheckField";
import { useNavigate } from "react-router-dom";

import { getUsuariosDTO } from "../Login/Users-Api";
import { IaxUserSelector } from "../UIComponents/IaxUserSelector";

import { getDepartamentos } from "../Departamento/Departamentos-Api";
import { IaxDeptSelector } from "../UIComponents/IaxDeptSelector";

import { CURSO_ACTIVO, cargarCursoActivo } from "../CursoAcademico/CursoAcademico-Api";
import { getUserLoggedLS } from "../../util/LocalStorageUtils";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import IaxGroupSelectorDialog from "../UIComponents/IaxGroupSelectorDialog";
import IaxGroupSummary from "../UIComponents/IaxGroupSummary";

export default function ActividadForm() {
  const [actividad, setActividad] = useState({});

  const [titulo, setTitulo] = useState(null);
  const [lugar, setLugar] = useState(null);
  const [descripcion, setDescripcion] = useState(null);
  const [observaciones, setObservaciones] = useState(null);
  const [fechaInicio, setFechaInicio] = useState(null);
  const [horaInicio, setHoraInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [horaFin, setHoraFin] = useState(null);
  const [coste, setCoste] = useState(null);
  const [necesitabus, setNecesitabus] = useState(null);
  const [departamentos, setDepartamentos] = useState(null);
  const [deptoId, setDeptoId] = useState(null);

  const [usuariosDTO, setUsuariosDTO] = useState(null);
  const [profesorResponsable, setProfesorResponsable] = useState(null);
  const [profesorAcomp1, setProfesorAcomp1] = useState(null);
  const [profesorAcomp2, setProfesorAcomp2] = useState(null);
  const [profesorAcomp3, setProfesorAcomp3] = useState(null);
  const [profesorAcomp4, setProfesorAcomp4] = useState(null);
  const [profesorAcomp5, setProfesorAcomp5] = useState(null);
  const [grupos, setGrupos] = useState([]);
  
  const [groupOpen, setGroupOpen] = useState(false);

  let { id } = useParams();

  const navigate = useNavigate();

  let userLogged = getUserLoggedLS();

  const setActividadYCarga = (act) => {
    console.log(act);

    setActividad(act);
    setTitulo(act.titulo);
    setLugar(act.lugar);
    setDescripcion(act.descripcion);
    setObservaciones(act.observaciones);
    setFechaInicio(act.fechaInicio);
    setHoraInicio(act.horaInicio);
    setFechaFin(act.fechaFin);
    setHoraFin(act.horaFin);
    setCoste(act.coste);
    setNecesitabus(act.necesitabus);
    setProfesorResponsable(act.profesorResponsable);
    setProfesorAcomp1(act.profesorAcomp1);
    setProfesorAcomp2(act.profesorAcomp2);
    setProfesorAcomp3(act.profesorAcomp3);
    setProfesorAcomp4(act.profesorAcomp4);
    setProfesorAcomp5(act.profesorAcomp5);
    setDeptoId(act.departamento.id);
    setGrupos(act.grupos);
  };

  const inicializaActividad = () => {
    actividad.imagen = null;
    actividad.activado = false;
    actividad.valorado = false;
    actividad.archivada = false;
    actividad.agencia = "";
    // no debería darse esto, además es asíncrono y no va a coger el curso
    if (CURSO_ACTIVO === undefined || CURSO_ACTIVO === null) {
      cargarCursoActivo();
    }
    actividad.cursoAcademico = CURSO_ACTIVO;
    actividad.grupos = [];
    actividad.valoracion = null;
  };



  const guardarActividad = (alterminar) => {
    if (actividad.id == null) {
      inicializaActividad();
    }

    actividad.titulo = titulo;
    actividad.lugar = lugar;
    actividad.descripcion = descripcion;
    actividad.observaciones = observaciones;
    actividad.fechaInicio = fechaInicio;
    actividad.horaInicio = horaInicio;
    actividad.fechaFin = fechaFin;
    actividad.horaFin = horaFin;
    actividad.coste = coste;
    actividad.necesitabus = necesitabus;
    actividad.profesorResponsable = profesorResponsable;
    actividad.profesorAcomp1 = profesorAcomp1;
    actividad.profesorAcomp2 = profesorAcomp2;
    actividad.profesorAcomp3 = profesorAcomp3;
    actividad.profesorAcomp4 = profesorAcomp4;
    actividad.profesorAcomp5 = profesorAcomp5;

    if (deptoId != null) {
      var depto = departamentos.find((x) => x.id === deptoId);
      actividad.departamento = depto;
    }
    actividad.grupos = grupos;
    if (actividad.id == null) {
      createActividad(actividad, alterminar);
    } else {
      updateActividad(actividad, alterminar);
    }
  };

  const alTerminarGuardado = () => {
    toast.success("Actividad guardada correctamente.", {
      onClose: () => {
        navigate(-1);
      },
    });
  };

  useEffect(() => {
    if (!isEmpty(userLogged)) {
      getUsuariosDTO(setUsuariosDTO);
      getDepartamentos(setDepartamentos);
      cargarCursoActivo();
      if (id !== undefined) {
        // cargamos actividad desde BE
        getActividadById(setActividadYCarga, id, userLogged.token);
      }
    }
  }, []);

  useEffect(() => {
    if (id == undefined && usuariosDTO != null) {
      // nueva actividad
      var profSel = usuariosDTO.find((x) => x.id === userLogged.id);
      setProfesorResponsable(profSel);
    }
  }, [usuariosDTO]);

  function handleSubmit(event) {
    event.preventDefault();
    console.log("Submit!");

    guardarActividad(alTerminarGuardado);
  }

  const handleCancel = () => {
    navigate(-1);
  };

  // control selector de grupos
  const abrirSelectorGrupos = (a) => {
    setActividadYCarga(a)
    setGroupOpen(true);
  }

  const handleOpenGroupSelectorDialog = () => {
    if (actividad.id == null) {
      guardarActividad(abrirSelectorGrupos);
    } else {
      setGroupOpen(true);
    }
  };

  const handleCloseGroupSelectorDialog = (actividad) => {
    if (actividad != undefined && actividad.grupos != undefined) {
      setGrupos(actividad.grupos);
    }    
    setGroupOpen(false);    
  };

  if (actividad) {
    return (
      <React.Fragment>
        <h2>Actividad {id}</h2>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <form onSubmit={handleSubmit} action={<Link to="/actividades" />}>
          <IaxTextField
            tfonchange={(e) => setTitulo(e.target.value)}
            tfvalue={titulo}
            tflabel="Título"
            tfrequired={true}
          />

          <IaxTextField
            tfonchange={(e) => setLugar(e.target.value)}
            tfvalue={lugar}
            tflabel="Lugar"
          />

          <IaxTextField
            tfonchange={(e) => setDescripcion(e.target.value)}
            tfvalue={descripcion}
            tflabel="Descripción"
          />

          <IaxDeptSelector
            uslabelid="departamento"
            uslabel="Departamento"
            usvalue={deptoId}
            usonchange={(e) => setDeptoId(e.target.value)}
            deptosdto={departamentos}
            usrequired={true}
          />

          <Stack spacing={2} direction="row">
            <IaxDateField
              tfonchange={(e) => setFechaInicio(e.target.value)}
              tfvalue={fechaInicio}
              tflabel="Fecha inicio"
            />

            <IaxTimeField
              tfonchange={(e) => setHoraInicio(e.target.value)}
              tfvalue={horaInicio}
              tflabel="Hora inicio"
            />
          </Stack>
          <Stack spacing={2} direction="row">
            <IaxDateField
              tfonchange={(e) => setFechaFin(e.target.value)}
              tfvalue={fechaFin}
              tflabel="Fecha fin"
            />

            <IaxTimeField
              tfonchange={(e) => setHoraFin(e.target.value)}
              tfvalue={horaFin}
              tflabel="Hora fin"
            />
          </Stack>

          <Stack spacing={2} direction="row">
            <IaxNumericField
              tfonchange={(e) => setCoste(e.target.value)}
              tfvalue={coste}
              tflabel="Coste"
            />
            <IaxCheckField
              tfonchange={(e,v) => setNecesitabus(v)}
              tfvalue={necesitabus}
              tflabel="Necesita bus"
            />
            <Stack sx={{textAlign: "center"}}>
              <Button
                variant="text"
                color="info"
                type="button"
                onClick={handleOpenGroupSelectorDialog}>
                Editar Grupos
              </Button>
              <IaxGroupSelectorDialog
                open={groupOpen}
                onClose={handleCloseGroupSelectorDialog}
                act={actividad}
              />
              <IaxGroupSummary 
                groups={grupos}  
               />  
            </Stack>

          </Stack>

          <IaxUserSelector
            uslabelid="profResp"
            uslabel="Profesor responsable"
            usvalue={profesorResponsable}
            usonchange={(e, v) => setProfesorResponsable(v)}
            ususuariosdto={usuariosDTO}
            usrequired={true}
            usdisabled={!userIsAdmin(userLogged)}
          />

          <IaxUserSelector
            uslabelid="profAcomp1"
            uslabel="Profesor acompañante 1"
            usvalue={profesorAcomp1}
            usonchange={(e, v) => setProfesorAcomp1(v)}
            ususuariosdto={usuariosDTO}
          />

          <IaxUserSelector
            uslabelid="profAcomp2"
            uslabel="Profesor acompañante 2"
            usvalue={profesorAcomp2}
            usonchange={(e, v) => setProfesorAcomp2(v)}
            ususuariosdto={usuariosDTO}
          />

          <IaxUserSelector
            uslabelid="profAcomp3"
            uslabel="Profesor acompañante 3"
            usvalue={profesorAcomp3}
            usonchange={(e, v) => setProfesorAcomp3(v)}
            ususuariosdto={usuariosDTO}
          />

          <IaxUserSelector
            uslabelid="profAcomp4"
            uslabel="Profesor acompañante 4"
            usvalue={profesorAcomp4}
            usonchange={(e, v) => setProfesorAcomp4(v)}
            ususuariosdto={usuariosDTO}
          />
          <IaxUserSelector
            uslabelid="profAcomp5"
            uslabel="Profesor acompañante 5"
            usvalue={profesorAcomp5}
            usonchange={(e, v) => setProfesorAcomp5(v)}
            ususuariosdto={usuariosDTO}
          />

          <IaxTextField
            tfonchange={(e) => setObservaciones(e.target.value)}
            tfvalue={observaciones}
            tflabel="Observaciones"
          />

          <Stack spacing={2} direction="row">
            <Button variant="contained" color="secondary" type="submit">
              Guardar
            </Button>
            <Button
              onClick={() => handleCancel()}
              variant="contained"
              color="warning"
              type="reset"
            >
              Cancelar
            </Button>
          </Stack>
        </form>
      </React.Fragment>
    );
  } else {
    return null;
  }
}
